import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';

export const SearchBox = styled.input`
  padding: 9px ${gutter(1)} 9px ${gutter(2)};

  border: 1px solid ${color('gray50')};
  font-size: 14px;

  &:hover {
    background-color: ${color('gray10')};
    border-color: #8f8f8f;
  }

  &:active {
    border-color: ${color('blue60')};
  }
`;
